import React, { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import { Sphere, Box, Cylinder } from '@react-three/drei';
import * as THREE from 'three';

interface Food3DModelProps {
  foodType: string;
  position?: [number, number, number];
  scale?: number;
  animated?: boolean;
}

const Food3DModel: React.FC<Food3DModelProps> = ({ 
  foodType, 
  position = [0, 0, 0], 
  scale = 1,
  animated = true 
}) => {
  const meshRef = useRef<THREE.Mesh>(null);

  useFrame((state) => {
    if (meshRef.current && animated) {
      meshRef.current.rotation.y = state.clock.elapsedTime * 0.5;
      meshRef.current.position.y = position[1] + Math.sin(state.clock.elapsedTime) * 0.1;
    }
  });

  const getFoodModel = () => {
    switch (foodType.toLowerCase()) {
      case 'apple':
        return (
          <Sphere ref={meshRef} args={[1, 32, 32]} position={position} scale={scale}>
            <meshStandardMaterial color="#ff4444" roughness={0.3} metalness={0.1} />
          </Sphere>
        );
      case 'bread':
        return (
          <Box ref={meshRef} args={[1.5, 0.8, 1]} position={position} scale={scale}>
            <meshStandardMaterial color="#deb887" roughness={0.8} metalness={0.1} />
          </Box>
        );
      case 'salmon':
        return (
          <Box ref={meshRef} args={[2, 0.5, 1.2]} position={position} scale={scale}>
            <meshStandardMaterial color="#fa8072" roughness={0.4} metalness={0.2} />
          </Box>
        );
      case 'broccoli':
        return (
          <Cylinder ref={meshRef} args={[0.8, 0.3, 1.5, 8]} position={position} scale={scale}>
            <meshStandardMaterial color="#228b22" roughness={0.6} metalness={0.1} />
          </Cylinder>
        );
      default:
        return (
          <Sphere ref={meshRef} args={[1, 32, 32]} position={position} scale={scale}>
            <meshStandardMaterial color="#8b5cf6" roughness={0.3} metalness={0.1} />
          </Sphere>
        );
    }
  };

  return (
    <group>
      {getFoodModel()}
      <pointLight position={[2, 2, 2]} intensity={0.5} color="#ffffff" />
    </group>
  );
};

export default Food3DModel;